import BaseCard from './BaseCard';
import { CardType } from './CardType';
import GameObject from '../../../GameObject/GameObject';
import Scissor from './Scissors';
import Container from '../../Container';

export default class ScissorCard extends BaseCard {
    public onCreate(params: any): void {
        params.cardFrontTexture = 'card_empty';
        params.type = CardType.scissors;
        super.onCreate(params);

        // Create modifier container.
        const modifierContainer = GameObject.Instantiate(Container, {
            name: 'modifierContainer',
        });

        modifierContainer.addChild(GameObject.Instantiate(Scissor));
        this.addChild(modifierContainer);
    }
}
